module.exports = __webpack_public_path__ + "img/11_21.ca439015.png";